import React from 'react';
import { Image } from '@src/interfaces';
import ImageComponent from '@src/components/Image/ImageComponent';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

const ImageParagraph = (props: ParagraphProps) => {
  const image = props.paragraph.data.image as Image;

  return (
    <figure className="image-paragraph paragraph">
      <ImageComponent image={image} showDescription size="large_uncropped" />
    </figure>
  );
};

export default ImageParagraph;
